import React, { PureComponent } from 'react'
import styled from 'styled-components'
import Asset from '../../components/asset/Asset'
import { IAssetData } from '../../helpers/data/assetData'
import Settings from './components/Settings'
import BlockedUser from './components/BlockedUser'
import { IGameSettings } from '../../helpers/data/gameSettings'

const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 1);
`

const BackgroundContainer = styled.div`
	width: 100%;
	height: 100%;
	margin: auto;
	position: absolute;
	top: 0;
	left: 0;
`

export interface ISkin {
	background: IAssetData
	animation: IAssetData
}

interface ISplashProps {
	onComplete: () => void
	onSettingsSubmit: (settings: any) => void
	settings: IGameSettings
	skin: ISkin
	canParticipate: boolean
	sessionType: string | number
}

class Splash extends PureComponent<ISplashProps> {
	render() {
		return (
			<Wrapper>
				<BackgroundContainer>
					<Asset asset={this.props.skin.background} />
				</BackgroundContainer>
				<BackgroundContainer>
					<Asset asset={this.props.skin.animation} onComplete={this.props.onComplete} />
				</BackgroundContainer>
				<Settings
					settings={this.props.settings}
					onSettingsSubmit={this.props.onSettingsSubmit}
				/>
				<BlockedUser canParticipate={this.props.canParticipate} sessionType={this.props.sessionType} />
			</Wrapper>
		)
	}
}

export default Splash
